( function ( _s ) {
	_s.fn.frHeader = function () {
		return this.el.forEach( header => {
			const _header = _s( header );
			const _mainContainer = _s( '#main' );
			const _navBar = _header.find( '.navbar-collapse' );
			const _navBarCollapse = new window.bs.Collapse(
				document.getElementById( 'navbarSupportedContent' ),
				{
					toggle: false,
				}
			);
			const _topMenuItems = _navBar.find( '.navbar-nav > .menu-item' );
			const _dropdownToggles = _topMenuItems
				.filter( '.menu-item-has-children' )
				.find( '> a' );
			const _searchFormDesktopToggle = _navBar.find( '#search-form-desktop-toggle' );
			const _searchFormDesktopContainer = _navBar.find( '.search-form-desktop' );
			const _submenus = _topMenuItems.find( '> .dropdown-menu' );
			const _loggedInDropdown = _header.find( '.logged-in-dropdown' );
			const _logoutLinks = _s( '[href="#logout"]' );
			const scrolledTriggerHideMenu = 10;
			const inFocusMode = _s( 'body' ).hasClass( 'ld-in-focus-mode' );
			let scrolled = window.scrollY;

			const isHome = () => {
				return _s( 'body' ).hasClass( 'home' );
			};

			const setBodyTopPadding = () => {
				_s( window ).trigger( 'fr:set-body-top-padding' );
			};

			const navScroll = ( init = false ) => {
				const currentScrolled = window.scrollY;

				collapseNav();

				hideSearchForm();

				hideLoggedInDropdown();

				if ( currentScrolled > scrolled ) {
					if ( isHome() && scrolled > 0 && ! _header.hasClass( 'hidden' ) )
						setWhiteBackground();

					// prettier-ignore
					if( (isHome() && currentScrolled >= scrolledTriggerHideMenu) || ( !isHome() && currentScrolled >= parseInt( window.getRootProperty( '--body-top-padding' ) ) ) ) _header.addClass( 'hidden' );
				}

				if ( currentScrolled < scrolled ) {
					if ( isHome() && currentScrolled === 0 ) removeWhiteBackground();
					if ( isHome() && currentScrolled > 0 ) setWhiteBackground();
					_header.removeClass( 'hidden' );
				}

				if ( init && currentScrolled > 0 ) _header.addClass( 'white-bg' );

				scrolled = currentScrolled;
			};

			const setWhiteBackground = () => {
				_header.addClass( 'white-bg' );
			};

			const removeWhiteBackground = () => {
				if ( isHome() ) _header.removeClass( 'white-bg' );
			};

			const collapseNav = () => {
				_navBarCollapse.hide();
			};

			const showNav = () => {
				_navBarCollapse.show();
			};

			const hideSearchForm = () => {
				_searchFormDesktopToggle.removeClass( 'show' );
				_searchFormDesktopToggle.attr( 'aria-expanded', false );
			};

			const hideLoggedInDropdown = () => {
				_loggedInDropdown.each( dropdown => {
					const _dropdownItems = _s( dropdown ).find( '.logged-in-dropdown-items' );
					if ( _dropdownItems.hasClass( 'show' ) ) {
						_s( `[href="#${ _dropdownItems.attr( 'id' ) }"]` ).trigger( 'click' );
					}
				} );
			};

			const removeToggleAttributes = () => {
				_dropdownToggles.each( dropdownToggle => {
					_s( dropdownToggle )
						.removeAttr( 'data-bs-toggle' )
						.removeAttr( 'aria-haspopup' )
						.removeAttr( 'aria-expanded' );
				} );
			};

			const addToggleAttribute = () => {
				_topMenuItems.each( topMenuItem => {
					_s( topMenuItem ).attr( 'aria-expanded', false );
				} );
			};

			const initHeaderResizeObserver = () => {
				const headerResizeObserver = new ResizeObserver( () => {
					_s( window ).trigger( 'fr:header-resized' );
				} );

				headerResizeObserver.observe( header );
			};

			const addSubmenuAttributes = () => {
				let index = 0;
				_submenus.each( submenu => {
					const _submenu = _s( submenu );
					const title = _submenu.parent().find( '.nav-link' ).text();

					_submenu.attr( 'id', `submenu-${ index }` );
					_submenu
						.closest( '.menu-item-has-children' )
						.removeAttr( 'aria-expanded' )
						.find( '.expand-submenu' )
						.attr( 'aria-controls', `submenu-${ index }` );
					_submenu.prepend(
						`<li class="submenu-title d-flex flex-row d-lg-none">${ title }<span class="collapse-submenu" aria-expanded="false" aria-controls="submenu-${ index }" tabindex="0"></span></div>`
					);

					index++;
				} );
			};

			const resetMobileNavigation = () => {
				setTimeout( () => {
					_submenus.each( submenu => {
						const _submenu = _s( submenu );
						const _collapseSubmenu = _submenu.find( '.collapse-submenu' );
						const _expandSubmenu = _submenu.parent().find( '.expand-submenu' );

						_submenu
							.closest( '.menu-item-has-children' )
							.attr( 'aria-expanded', false );
						_collapseSubmenu.attr( 'aria-expanded', false );
						_expandSubmenu.attr( 'aria-expanded', false );
						_navBar.removeClass( 'submenu-expanded' );
					} );
				}, 500 );
			};

			const init = () => {
				setBodyTopPadding();

				navScroll( true );

				removeToggleAttributes();

				addToggleAttribute();

				initHeaderResizeObserver();

				addSubmenuAttributes();

				_s( window ).on( 'resize fr:body-height-changed fr:header-resized', () => {
					setBodyTopPadding();
				} );

				_s( window ).on( 'fr:body-click', e => {
					const clicked = e.detail.target;

					if (
						! _s( clicked ).closest( '.login-link-container' ).length &&
						! _s( clicked ).filter( '.login-link-container' ).length
					) {
						_loggedInDropdown
							.find( '[data-bs-toggle="collapse"][aria-expanded="true"]' )
							.trigger( 'click' );
					}
				} );

				_s( window ).on( 'scroll', () => {
					/** Prevent filters from collapsing when dropdown is expanded */
					if ( _s( '.filters-visible' ).length || window.navbarLocked ) return;

					navScroll();
				} );

				_navBar.on( 'show.bs.collapse', function () {
					setWhiteBackground();
				} );

				_navBar.on( 'hide.bs.collapse', function () {
					if ( window.scrollY === 0 ) {
						removeWhiteBackground();
					}
					resetMobileNavigation();
				} );

				_dropdownToggles.on( 'click keyup', e => {
					e.preventDefault();

					if ( e.type === 'keyup' && ! window.isEventKeyEnter( e ) )
						return; /** Not enter */

					const _link = _s( e.target );
					const href = _link.attr( 'href' );
					const urlRegex = /^(http|https):\/\/[^ "]+$/;
					const target = _link.attr( 'target' );

					if ( urlRegex.test( href ) ) {
						window.open( href, target !== '_blank' ? '_self' : target );
					} else {
						_link.closest( '.menu-item' ).trigger( 'click' );
					}
				} );

				/**
				 * Expand mobile submenu by clicking on empty link (e.g. href="#")
				 */
				_topMenuItems.on( 'click', e => {
					const _menuItem = _s( e.target );

					if (
						_menuItem.hasClass( 'menu-item' ) &&
						_menuItem.hasClass( 'menu-item-has-children' )
					) {
						const show = _menuItem.attr( 'aria-expanded' ) !== 'true';

						if ( ! show ) return; /** Already expanded */

						_menuItem.attr( 'aria-expanded', true );
						_menuItem.find( '.collapse-submenu' ).attr( 'aria-expanded', true );
						_menuItem.find( '.expand-submenu' ).attr( 'aria-expanded', true );
						_navBar.addClass( 'submenu-expanded' );
					}
				} );

				/** Add small delay to menu dropdowns animation */

				let hoverTimer;

				_topMenuItems.on( 'mouseenter', e => {
					hoverTimer = setTimeout( function () {
						_s( e.target ).addClass( 'show-submenu' );
					}, 300 );
				} );

				_topMenuItems.find( '> a' ).on( 'focusin', e => {
					_s( e.target ).closest( '.menu-item' ).addClass( 'show-submenu' );
				} );

				_topMenuItems.on( 'mouseleave', e => {
					clearTimeout( hoverTimer ); // Clear the timer if the mouse leaves the element before the time is up
					_s( e.target ).removeClass( 'show-submenu' );
				} );

				_topMenuItems.find( '> a' ).on( 'focusout', e => {
					const _navLinkParent = _s( e.target ).closest( '.menu-item' );
					if (
						! _navLinkParent.length ||
						! _navLinkParent.firstElement().contains( e.relatedTarget )
					) {
						_s( e.target ).closest( '.menu-item' ).removeClass( 'show-submenu' );
					}
				} );

				/**
				 * Expand mobile submenu by clicking on toggle
				 */
				_topMenuItems.find( '.expand-submenu' ).on( 'click keyup', e => {
					const _expandSubmenu = _s( e.target );
					const _menuItem = _expandSubmenu.closest( '.menu-item-has-children' );
					const expand = _menuItem.attr( 'aria-expanded' ) !== 'true';

					if ( e.type === 'keyup' && ! window.isEventKeyEnter( e ) )
						return; /** Not enter */

					if ( ! expand ) return; /** Already expanded */

					_expandSubmenu.attr( 'aria-expanded', true );
					_menuItem.find( '.collapse-submenu' ).attr( 'aria-expanded', true );
					_menuItem.attr( 'aria-expanded', true );
					_navBar.addClass( 'submenu-expanded' );

					setTimeout( function () {
						_menuItem.find( '.collapse-submenu' ).focus();
					}, 500 ); /** Wait until the element is focusable */
				} );

				/**
				 * Collapse mobile submenu by clicking on toggle
				 */
				_topMenuItems.find( '.collapse-submenu' ).on( 'click keyup', e => {
					const _collapseSubmenu = _s( e.target );
					const _menuItem = _collapseSubmenu.closest( '.menu-item-has-children' );
					const collapse = _menuItem.attr( 'aria-expanded' ) === 'true';

					if ( e.type === 'keyup' && ! window.isEventKeyEnter( e ) )
						return; /** Not enter */

					if ( ! collapse ) return; /** Already collapsed */

					_collapseSubmenu.attr( 'aria-expanded', false );
					_menuItem.find( '.expand-submenu' ).attr( 'aria-expanded', false );
					_menuItem.attr( 'aria-expanded', false );
					_navBar.removeClass( 'submenu-expanded' );
				} );

				/** Show search form */
				_searchFormDesktopToggle.on( 'click keyup', e => {
					if ( e.type === 'keyup' && ! window.isEventKeyEnter( e ) ) return;

					const show = ! _searchFormDesktopToggle.hasClass( 'show' );

					_searchFormDesktopToggle.toggleClass( 'show' );
					_searchFormDesktopToggle.attr( 'aria-expanded', show );

					if ( show ) {
						setWhiteBackground();
						_searchFormDesktopContainer.find( '[type="text"]' ).focus();
					} else if ( ! window.scrollY ) removeWhiteBackground();
				} );

				/** Hide search form if dropdown toggle is hovered */
				_dropdownToggles.on( 'mouseenter focus', () => {
					if ( _searchFormDesktopToggle.hasClass( 'show' ) ) {
						_searchFormDesktopToggle.trigger( 'click' );
					}
				} );

				if ( inFocusMode ) {
					const _focus = _s( '.ld-focus' );

					_loggedInDropdown.on( 'show.bs.collapse', () => {
						if ( ! _focus.hasClass( 'ld-focus-sidebar-collapsed' ) ) {
							_focus.find( '.ld-focus-sidebar-trigger' ).each( sidebarTrigger => {
								sidebarTrigger.click();
							} );
						}
					} );

					_navBar.on( 'show.bs.collapse', () => {
						if ( ! _focus.hasClass( 'ld-focus-sidebar-collapsed' ) ) {
							_focus.find( '.ld-focus-sidebar-trigger' ).each( sidebarTrigger => {
								sidebarTrigger.click();
							} );
						}
					} );
				}

				_logoutLinks.each( link => {
					_s( link ).on( 'click', e => {
						e.preventDefault();
						const _logoutLink = _loggedInDropdown.find( '.logout-link a' );

						if ( _logoutLink.length ) {
							_logoutLink.firstElement().click();
						}
					} );
				} );

				setTimeout( () => {
					_header.addClass( 'initialized' );
				}, 500 );
			};

			init();
		} );
	};

	_s( document ).ready( () => {
		_s( '#app > header' ).frHeader();
	} );
} )( window._s );
